const state = {
  isFullscreen: false,
  reloadTable: false,
}

const getters = {
  getReloadTable: (state) => {
    return state.reloadTable
  },

  getIsFullscreen: (state) => {
    return state.isFullscreen
  },
}

const mutations = {
  setReloadTable(state) {
    state.reloadTable = !state.reloadTable
  },

  setIsFullscreen: (state, payload) => {
    state.isFullscreen = payload === undefined ? !state.isFullscreen : payload
    state.reloadTable = !state.reloadTable
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
